import { TaggedError } from "@for-it/domain-lib";
export class ApplyToPublicationAlreadyExists extends TaggedError {
    constructor() {
        super("ApplyToPublicationAlreadyExists");
    }
}
